<template>
  <div class="chat-list-container">
    <div class="chat-header">
      <div class="chat-date">
        {{ currentDate }}
      </div>
    </div>

    <div class="chat-list" ref="scroll">
      <!--  챗봇 시작 데이터   -->
      <div class="chat-message bot">
        <img :src="require('@/assets/images/chatbot.png')" alt="Profile" class="profile-icon">
        <div class="message-box">
          <pre class="message-content">{{$t('chatBot.descriptionData')}}</pre>
        </div>
      </div>

      <!--  chat   -->
      <div class="chat-message"
           v-for="(message, index) in chatList"
           :key="index"
           :class="[isMe(message.userId) ? 'user' : 'bot']">
        <img v-show="!isMe(message.userId)" :src="require('@/assets/images/chatbot.png')" alt="Profile" class="profile-icon">
        <div class="message-box">
          <pre class="message-content">{{ message.text }}</pre>
        </div>
        <div class="message-time">{{ message.time }}</div>
      </div>

      <div v-show="isChatSent" class="chat-message bot">
        <img :src="require('@/assets/images/chatbot.png')" alt="Profile" class="profile-icon">
        <div class="message-box">
          <GrmLoadingCircle/>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import {mapGetters} from "vuex";
import GrmLoadingCircle from "@/components/Common/loading/GrmLoadingCircle.vue";

export default {
  name: 'BotChatList',
  components: {GrmLoadingCircle},
  computed: {
    ...mapGetters('user', [
      'isMe',
    ]),
    ...mapGetters('chatBot', [
      'getChatList',
      'getCurrentReceiveMessage',
      'isChatSent',
    ]),
    chatList() {
      return this.getChatList;
    },
    currentDate() {
      const today = new Date();
      if (this.$i18n.locale === 'en')
        return today.toLocaleDateString("en", {weekday: 'long', day: '2-digit', month: 'long', year: 'numeric'});
      else
        return today.toLocaleDateString("ko", {weekday: 'long', day: '2-digit', month: 'long', year: 'numeric'});
    }
  },
  watch: {
    isChatSent: function() {
      this.toBottomScroll();
    },
  },
  methods: {
    toBottomScroll(){
      this.$nextTick(() => {
        const scroll = this.$refs.scroll
        scroll.scrollTo({left: 0, top: scroll.scrollHeight})
      })
    },
  },
}

</script>

<style lang="scss" scoped>
.chat-list-container {
  height: 90%;
  display: flex;
  flex-direction: column;
}
.chat-list {
  overflow-y: auto;
  height: 90%;
}
.chat-header {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 20px;
  margin-bottom: 36px;
}
.chat-date {
  font-size: 14px;
  background-color: #EDF4FF;
  padding: 5px 10px;
  border-radius: 15px;
  text-align: center;
  width: 35%;
  margin: 10px auto;
}
.chat-message {
  display: flex;
  margin-bottom: 10px;

  &.bot {
    justify-content: flex-start;
  }

  &.user {
    justify-content: flex-end;
  }
}
.message.incoming {
  justify-content: flex-start;
}
.message.outgoing {
  justify-content: flex-end;
}
.message-box {
  max-width: 60%;
  padding: 10px;
  border-radius: 10px;
  font-size: 14px;
  line-height: 1.4;

  .bot & {
    background-color: #f1f1f1;
  }
  .user & {
    background-color: #EDF4FF;
  }
}
.message-content {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: break-spaces;
}

.message-content.incoming {
  background-color: #f1f1f1;
}
.message-content.outgoing {
  background-color: #EDF4FF;
}
.message-time {
  align-self: flex-end;
  font-size: 10px;
  color: #888;
  margin: 0 5px;
}
.profile-icon {
  width: 30px;
  height: 30px;
  margin-right: 10px;
  background-color: #dadada;
}
</style>